<template>
  <div class="flex h-full flex-col gap-6">
    <AuditLogTable
      :has-more-items="!auditLogStore.options.lastPage"
      :loading="auditLogStore.loading"
      :page="auditLogStore.options.page"
      :rows="auditLogStore.items"
      :search-enabled="false"
      :show-user-id="false"
      @click-row="redirectToAuditLog"
      @load="auditLogStore.loadMore()"
    />
  </div>
</template>

<script setup lang="ts">
import { FilterExpression, notEquals } from '@infuse/api/common';
import { AuditLog, useAuditLogStore } from '@infuse/audit-log/store';
import { AuditLogTable } from '@infuse/audit-log/ui';
import { User } from '@infuse/iam/user/type';
import { watch } from 'vue';
import { useRouter } from 'vue-router';

const auditLogStore = useAuditLogStore();
const router = useRouter();

const props = defineProps<{
  model: User;
  isLoading: boolean;
}>();

interface Emits {
  (e: 'reload-model'): void;
}
defineEmits<Emits>();

watch(
  () => props.model,
  () => {
    if (props.model) {
      auditLogStore.resetOptions();

      // Results only for this user, and no read access (too much spam).
      auditLogStore.setFilter(
        new FilterExpression().equals('userId', props.model?.externalId).and(notEquals('httpMethod', 'GET'))
      );
      auditLogStore.search();
    }
  },
  { immediate: true }
);

const redirectToAuditLog = (row: AuditLog): void => {
  router.push({
    name: 'audit-logs.details',
    params: { id: row.id }
  });
};
</script>
